import { FC } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { PATHS } from "./paths";
import HomePage from "./pages/home";
import AboutPage from "./pages/about";
import SecuritasGroupPage from "./pages/about/pages/securitasGroup";
import OurValuesPage from "./pages/about/pages/ourValues";
import QualityManagementPage from "./pages/about/pages/qualityManagement";
import FireServicePage from "./pages/services/FireServicePage";
import WatchServicePage from "./pages/services/WatchServicePage";
import MultiRoleServicePage from "./pages/services/MultiRoleServicePage";
import EducationsPage from "./pages/educations";
import TrainingDetailPage from "./pages/educations/TrainingDetailPage";
import { TRAININGS } from "./pages/educations/trainings";
import BlogPage from "./pages/blog";
import BlogDetailPage from "./pages/blog/pages/[slug]";

// Kaldırılan sayfaların eski adresleri, arama motorlarında ve dış linklerde kalmış olabilir.
const REDIRECTS: { from: string; to: string }[] = [
  { from: PATHS.services, to: PATHS.fire },
  { from: `${PATHS.multiRole}/*`, to: PATHS.multiRole },
  { from: "/fce", to: PATHS.home },
  { from: `${PATHS.trainings}/guvenlik-yaklasimi/*`, to: PATHS.trainings },
  { from: `${PATHS.trainings}/guvenlik-yaklasimi`, to: PATHS.trainings },
  { from: `${PATHS.trainings}/yanginda-ilk-5-dakika`, to: PATHS.fire },
  { from: `${PATHS.trainings}/ilk-5-dakika`, to: PATHS.fire },
  {
    from: `${PATHS.trainings}/services-ileri-seviye-atesli-temel-itfaiye-egitimi`,
    to: PATHS.trainingAdvanced,
  },
  {
    from: `${PATHS.trainings}/services-teorik-ve-uygulamali-yangin-egitimi`,
    to: PATHS.trainingTheory,
  },
  {
    from: `${PATHS.trainings}/services-yanginda-davranis-sekilleri`,
    to: PATHS.trainingFireBehaviour,
  },
  { from: `${PATHS.blog}/detail`, to: PATHS.blog },
];

const Routing: FC = () => (
  <Routes>
    <Route path={PATHS.home} element={<HomePage />} />

    <Route path={PATHS.about} element={<AboutPage />} />
    <Route path={PATHS.group} element={<SecuritasGroupPage />} />
    <Route path={PATHS.values} element={<OurValuesPage />} />
    <Route path={PATHS.quality} element={<QualityManagementPage />} />

    <Route path={PATHS.fire} element={<FireServicePage />} />
    <Route path={PATHS.watch} element={<WatchServicePage />} />
    <Route path={PATHS.multiRole} element={<MultiRoleServicePage />} />

    <Route path={PATHS.trainings} element={<EducationsPage />} />
    {TRAININGS.map((training) => (
      <Route
        key={training.path}
        path={training.path}
        element={<TrainingDetailPage training={training} />}
      />
    ))}

    <Route path={PATHS.blog} element={<BlogPage />} />
    <Route path={`${PATHS.blog}/:slug`} element={<BlogDetailPage />} />

    {REDIRECTS.map(({ from, to }) => (
      <Route key={from} path={from} element={<Navigate to={to} replace />} />
    ))}
    <Route path="*" element={<Navigate to={PATHS.home} replace />} />
  </Routes>
);

export default Routing;
